<template>
  <div class="profile-form">
    <validation-observer ref="profileFormObserver" v-slot="{ passes, pristine }">
      <b-form class="profile-form__form form" @submit.stop.prevent="passes(submit)">
        <b-row>
          <b-col>
            <forms-validated-input
              name="name"
              :label="($t('fields.name') + '*') | capitalize"
              :rules="form.general.name.rules"
              type="text"
              @keypress.native="onlyChars"
              v-model="user.name"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <forms-validated-input
              name="last_name"
              :label="($t('fields.last_name') + '*') | capitalize"
              :rules="{ required: true }"
              type="text"
              v-model="user.last_name"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <forms-validated-input
              name="postal_code"
              :label="($t('fields.postal_code') + '*') | capitalize"
              :rules="{ required: true }"
              type="text"
              v-model="user.postal_code"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <forms-validated-input
              name="phone"
              :label="$t('fields.phone') | capitalize"
              description="Pour faciliter la communication votre numéro est visible
par les membres de votre groupe et l'équipe Coloc'Auto""
              :rules="form.general.phone.rules"
              type="text"
              mask="## ## ## ## ##"
              v-model="user.phone"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col class="profile-picture-uploader">
            <div class="circle">
              <forms-validated-input
                type="image"
                label="Une photo de profil?"
                :rules="form.general.avatar.rules"
                name="avatar"
                v-model="user.avatar"
              />
            </div>
          </b-col>
        </b-row>

        <slot />

        <div class="form__buttons text-end" v-if="!hideButtons">
          <layout-loading with-button v-if="loading" />
          <b-button variant="primary" type="submit" :disabled="loading || pristine">
            {{ ($route.name.match('register-') ? $t("suivant") : $t("enregistrer")) | capitalize }}
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import FormsValidatedInput from "@/components/Forms/ValidatedInput.vue";

import FormLabelsMixin from "@/mixins/FormLabelsMixin";

import locales from "@/locales";

import SmilingHeart from "@/assets/svg/smiling-heart.svg";

import { extend } from "vee-validate";

export default {
  name: "ProfileForm",
  mixins: [FormLabelsMixin],
  components: {
    FormsValidatedInput,
    "svg-smiling-heart": SmilingHeart,
  },
  props: {
    changed: {
      type: Boolean,
      required: false,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    hideButtons: {
      type: Boolean,
      required: false,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    const from = new Date();
    from.setDate(from.getDate() - 1);

    return {
      isPerson: true,
      openDate: new Date("1985-01-01"),
      datesInTheFuture: {
        from,
      },
      submitted: false,
    };
  },
  i18n: {
    messages: {
      en: {
        ...locales.en.users,
        ...locales.en.forms,
      },
      fr: {
        ...locales.fr.users,
        ...locales.fr.forms,
      },
    },
  },
  computed: {
  },
  methods: {
    setLocation(address, isFromGoogle) {
      this.$refs.addressValidator.setFlags({ pristine: false });
      this.user.address = address;
      this.$refs.addressValidator.syncValue({ address, isFromGoogle });
    },
    onlyChars(event) {
      if (!this.isPerson) {
        return true;
      }

      if (event.key.match(/[0-9]/)) {
        event.preventDefault();
        return false;
      }

      return true;
    },
    submit(...params) {
      this.$emit("submit", ...params);
      this.submitted = true;
    },
  },
};
</script>

<style lang="scss">
.profile-form {
  label {
    color: #1a1a1a;
    font-weight: 400;
    font-size: 14px;
  }

  .hide-label {
    label {
      display: none !important;
    }
  }

  h2.allo-title {
    text-align: left;
    margin: 15px 0 25px 0;
    svg {
      width: 60px;
      position: relative;
      top: -3px;
    }
  }

  .profile-picture-uploader {
    text-align: center;
    label {
      margin: 20px 0;
      font-size: $h3-font-size;
      line-height: $h3-line-height;
    }
    figure {
      height: 200px;
      width: 200px;
      background-color: $locomotion-green;
      border-radius: 50%;
      display: inline-block;
      overflow: hidden;
      margin: 0 !important;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .custom-file-label {
      border: none;
      background-image: none;
      height: 200px;
      width: 200px;
      background-color: $locomotion-green;
      border-radius: 50%;
      margin: 0 auto;
      overflow: inherit;
      background-image: url("/white-female-face.svg");
      &::after {
        background-color: #245ae9;
        border-radius: 32px;
        font-size: 16px;
        color: white;
        bottom: 1rem;
        font-weight: 600;
        z-index: 4;
      }
    }

    button {
      display: block;
      margin: 20px auto;
    }
  }

  .form__buttons {
    margin-top: 20px;
    .btn-primary {
      margin-left: 0;
    }
  }

  .safety-questions {
    h2,
    h3 {
      color: #047249;
    }

    h3 {
      font-size: 18px;
    }
  }
}
</style>
